import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import * as Ui from './AddProductsModalFooter.styles';

const AddProductsModalFooter = ({ productsToAdd, onSave, onCancel }) => {
  const { t } = useTranslation('ownerPortal');
  return (
    <Ui.Footer>
      <Ui.ButtonsWrapper>
        <Button variant="white" onClick={onCancel} className="rounded">
          {t('app:cancel')}
        </Button>
        <Button
          variant="primary"
          className="rounded"
          disabled={!productsToAdd.length}
          onClick={onSave}
        >
          {t('app:save')}
        </Button>
      </Ui.ButtonsWrapper>
    </Ui.Footer>
  );
};

export default AddProductsModalFooter;
